module.exports = __webpack_public_path__ + "img/logo.2815960b.png";